import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClientForm from './pages/ClientForm';
import AdminPanel from './pages/AdminPanel';
import AdminLogin from './pages/AdminLogin';
import LicenseVerification from './pages/LicenseVerification';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ClientForm />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/licenca/verificar" element={<LicenseVerification />} />
      </Routes>
    </Router>
  );
}

export default App;
